import React from "react";
import ReactApexChart from "react-apexcharts";
import styled from "styled-components";
import {WidgetReferralsCard} from "./referrals";
import {useTranslation} from "react-i18next";
import {IconDownloadApp} from "../icons";
import {CardCount, CardHeader, CardIcon} from "./dashboard";

const WidgetInstallsCard = styled(WidgetReferralsCard)`
	gap: 0;
	padding-bottom: 5px; //because of Chart inner extra space for drawing
`

const WidgetChartContainer = styled.div`
	width: 100%;
	margin-bottom: -10px;
`

const InstallsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
`

const InstallsTitle = styled.div`
    color: var(--it-text-white);
		margin-left: 4px;
    /* Buttons big */
    font-family: "Basis Grotesque Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    letter-spacing: 0.48px;
    text-transform: uppercase;
`

export const WidgetInstalls = ({data, count}) => {
	const {t} = useTranslation();

	// TODO: remove HARD-CODE data !!!
	data.categories = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul"
	];
	// TODO: remove HARD-CODE data !!!
	data.series = [450, 600, 400, 420, 470, 500, 500];
	count = '10.401';

	const series = [
		{
			name: t('widget.installs.title'),
			data: data?.series ?? []
		}
	];

	const options = {
		chart: {
			id: "WidgetInstalls",
			toolbar: {
				show: false,
			},
		},
		dataLabels: {
			enabled: false
		},
		colors: ['#16BC53'],
		fill: {
			//fill: 'linear-gradient(174deg, rgba(22, 188, 83, 0.15) 15.44%, rgba(22, 188, 83, 0.00) 96.77%)',
			type: "gradient",
			gradient: {
				shade: 'dark',
				shadeIntensity: 1,
				opacityFrom: 0.5,
				opacityTo: 0.15,
				stops: [0, 90, 100]
			}
		},
		xaxis: {
			categories: data?.categories ?? [],
			labels: {
				show: true,
				style: {
					colors: '#fff',
					fontFamily: "Basis Grotesque Pro",
					fontSize: '12px',
					fontWeight: 400,
				}
			},
			tooltip: {
				enabled: false
			},
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: true,
				borderType: 'solid',
				color: 'rgba(255, 255, 255, 0.60)',
				height: 6,
			},
			crosshairs: {
				show: true,
			}
		},
		yaxis: {
			min: 0,
			tickAmount: 3,
			labels: {
				show: true,
				style: {
					colors: '#fff',
					fontFamily: "Basis Grotesque Pro",
					fontSize: '12px',
					fontWeight: 400,
				},
				/*formatter: (value) => {
					console.log('yaxis --- formatter --- value:: ', value);
					return value
				},*/
			},
			axisBorder: {
				show: false,
			},
			axisTicks: {
				show: false,
			}
		},
		grid: {
			show: false,
			/*padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			},*/
		},
		stroke: {
			show: true,
			curve: 'smooth',
			width: 2,
		},
		tooltip: {
			enabled: true,
			style: {
				fontSize: '12px',
				fontFamily: "Basis Grotesque Pro"
			},
			custom: function({ series, seriesIndex, dataPointIndex, w }) {
				return (`
					<div class="arrow_box" 
							 style="padding: 5px 10px; font-family: 'Basis Grotesque Pro'; font-size: 14px; font-weight: 400; color: #000"
				  >
						<span>
							${series[seriesIndex][dataPointIndex]}
						</span>
					</div>
				`);
			},
			/*x: {
				show: false,
			},*/
			/*y: {
				formatter: (value) => `${value}`,
				title: {
					formatter: (seriesName) => '',
				},
			},*/
			marker: {
				show: false,
			},
		},
		noData: {
			text: 'NO DATA',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
				color: '#fff',
				fontSize: '18px',
				fontFamily: 'Basis Grotesque Pro'
			}
		}
	};

	return (
		<WidgetInstallsCard>
			<InstallsHeader>
				<CardHeader>
					<CardIcon><IconDownloadApp size={20}/></CardIcon>
					<InstallsTitle>{t('widget.installs.title')}</InstallsTitle>
				</CardHeader>
				<CardCount>{count}</CardCount>
			</InstallsHeader>


			<WidgetChartContainer>
				<ReactApexChart
					options={options}
					series={series}
					type={'area'}
					width={`100%`}
					height={'170px'}
				/>
			</WidgetChartContainer>
		</WidgetInstallsCard>
	)
}